var chunkToChildrenMap = {
	"5743": [
		433,
		8175,
		5933,
		3680
	],
	"8027": [
		433,
		8175,
		5933,
		3680
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));